<template>
  <div class="diagram-line-chart">
    <div
      class="diagram-line-chart__graph-sec"
      :style="{minHeight:`${lineHeight * lineLen}px`,paddingLeft:`${paddingLeft}px`}"
    >
      <div
        class="diagram-line-chart__graph-sec__content"
        :style="{minHeight:`${lineHeight * lineLen}px`}"
      >
        <DiagramLineSec
          :lines="_getEventsLineUsing"
          :range="[yMax,0]"
          :line-colors="_getLineColor"
          :dot-colors="_getDotColor"
          :total-height="lineHeight * lineLen"
          :ing-hover-index="ingHoverIndex"
          :has-dot="hasDot"
          :data-length="bottomLabels.length"
          :smooth-size="smoothSize"
        />
        <div class="diagram-line-chart__graph-sec__content-bg">
          <div
            v-for="(bg,bgIndex) in lineLen"
            :key="bgIndex"
            class="diagram-line-chart__graph-sec__content-bg-item"
          />
        </div>
        <DiagramTooltip
          :label-width="12"
          :label-height="3"
          :label-radius="1.5"
          :tooltips="tooltips"
          :length="bottomLabels.length"
          @hover-in="$_setIngHover($event)"
          @hover-out="$_unsetIngHover()"
        />
      </div>
      <DiagramFrequencySec
        :frequency-range="[yMax,0]"
        :title="yTitle"
        :max="lineLen"
        :unit="frequencyUnit"
      />
    </div>
    <div
      class="diagram-line-chart__bottom-label-sec"
      :style="{paddingLeft:`${paddingLeft}px`}"
    >
      <div
        v-for="(label,labelIndex) in bottomLabels"
        :key="labelIndex"
        class="diagram-line-chart__bottom-label"
      >
        {{ label }}
      </div>
    </div>
    <DiagramSwitchSec
      :padding-left="paddingLeft"
      :title="switchBtnTitle"
      @pre-click="$_switchSecPreClick($event)"
      @next-click="$_switchSecNextClick($event)"
    />
    <DiagramStatusLabel
      :status-items="statusItems"
      :value="itemsChecked"
      :label-width="12"
      :label-height="3"
      :label-radius="1.5"
      @input="$_statusOnChange($event)"
    />
  </div>
</template>
<script>
export default {
  name: "DiagramLineChart",
  props: {
    yTitle: {
      type: String,
      default: "",
    },
    statusItems: {
      type: Array,
      default() {
        return [];
      },
    },
    yMax: {
      type: Number,
      default: 0,
    },
    lineLen: {
      type: Number,
      default: 0,
    },
    bottomLabels: {
      type: Array,
      default() {
        return [];
      },
    },
    eventsList: {
      type: Object,
      default() {
        return {};
      },
    },
    tooltips: {
      type: Object,
      default() {
        return {};
      },
    },
    paddingLeft: {
      type: Number,
      default: 0,
    },
    switchBtnTitle: {
      type: String,
      default: "",
    },
    hasDot: {
      type: Boolean,
      default: false,
    },
    lineHeight: {
      type: Number,
      default: 24,
    },
    frequencyUnit: {
      type: String,
      default: "",
    },
    smoothSize: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    itemsChecked: [],
    ingHoverIndex: -1,
  }),
  computed: {
    _getEventsLineUsing() {
      const eventsLineUsing = [];
      this.bottomLabels.forEach((label) => {
        const eventLine = this.eventsList[label];
        if (eventLine) {
          this.itemsChecked.forEach((status, statusIndex) => {
            let itemsCheckedType = this.statusItems.find(
              (item) => item.value === status
            );
            if (eventsLineUsing[statusIndex]) {
              eventsLineUsing[statusIndex].push(
                eventLine[itemsCheckedType.type]
              );
            } else {
              eventsLineUsing[statusIndex] = [
                eventLine[itemsCheckedType.type],
              ];
            }
          });
        } else {
          this.itemsChecked.forEach((status, statusIndex) => {
            if (eventsLineUsing[statusIndex]) {
              eventsLineUsing[statusIndex].push(0);
            } else {
              eventsLineUsing[statusIndex] = 0;
            }
          });
        }
      });
      return eventsLineUsing.reverse();
    },
    _getLineColor() {
      let result = [];
      this.itemsChecked.forEach((itemsChecked) => {
        let itemsCheckedType = this.statusItems.find(
          (item) => item.value === itemsChecked
        );
        result.push(itemsCheckedType.lineColor);
      });
      return result.reverse();
    },
    _getDotColor() {
      let result = [];
      this.itemsChecked.forEach((itemsChecked) => {
        let itemsCheckedType = this.statusItems.find(
          (item) => item.value === itemsChecked
        );
        result.push(itemsCheckedType.dotColor);
      });
      return result.reverse();
    },
  },
  watch: {
    statusItems: {
      deep: true,
      immediate: true,
      handler() {
        this.$_setitemsChecked();
      },
    },
  },
  methods: {
    $_statusCheck(status) {
      let check = false;
      for (let i = 0; i < this.itemsChecked.length; i++) {
        const itemsCheckedItem = this.itemsChecked[i];
        if (itemsCheckedItem == status) {
          check = true;
        }
      }
      return check;
    },
    $_statusColor(status) {
      let checked = this.$_statusCheck(status.value);
      return checked ? status.color : status.disabledColor;
    },
    $_setitemsChecked() {
      this.itemsChecked = this.statusItems.map((item) => item.value);
    },
    $_getBarHeight(bar_e) {
      return (bar_e / this.yMax) * 100;
    },
    $_gerBarColor(barItemKey) {
      let itemsChecked = this.statusItems.find(
        (item) => item.type === barItemKey
      );
      return itemsChecked.color;
    },
    $_setIngHover(index) {
      this.ingHoverIndex = index;
    },
    $_unsetIngHover() {
      this.ingHoverIndex = -1;
    },
    $_statusOnChange($event) {
      this.itemsChecked = $event;
    },
    $_switchSecPreClick($event) {
      this.$emit("pre-click", $event);
    },
    $_switchSecNextClick($event) {
      this.$emit("next-click", $event);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/diagram-line-chart";
</style>